import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import routes from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((routeTo, routeFrom, next) => {
    const publicPages = ['/login', '/register', '/forgot-password'];
    const authpage = !publicPages.includes(routeTo.path);
    const loggeduser = localStorage.getItem('user');
    if (authpage && !loggeduser) {
      return next('/login');
    }

    const requiredPermission = routeTo.matched.find((route) => route.meta && route.meta.permission)?.meta?.permission;
    if (requiredPermission && loggeduser) {
      const parsedUser = JSON.parse(loggeduser);
      const isAdministrator = (parsedUser?.role || '').toString().toLowerCase() === 'administrator';
      const isPsychologyRoute = ['view_psychology', 'create_psychology_patient', 'edit_psychology_patient', 'delete_psychology_patient', 'psychology_consultations', 'psychology_group_programs', 'psychology_assessments_tests', 'psychology_corporate_services', 'psychology_sensitive_services'].includes(requiredPermission);
      if (isPsychologyRoute && parsedUser?.settings?.psychology != 1) {
        return next('/');
      }
      const hasPermission = isAdministrator || parsedUser?.permissions?.[requiredPermission] == 1;
      if (!hasPermission) {
        return next('/');
      }
    }

    next();
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }
  next()
})

export default router

